import http from '@/plugins/http';
import reportError from '@/utils/reportError';

// When the request succeeds
const success = (response, onSuccessCallback) => {
  onSuccessCallback(response);
};

// When the request fails
const failed = (error, onFailureCallback) => {
  onFailureCallback(error);
};

export default (email, fromCheckout, onFailureCallback, onSuccessCallback) => {
  http.delete(`me/customer/${email}/password`, { params: { from_checkout: fromCheckout ? 1 : 0 } })
    .then((response) => {
      success(response, onSuccessCallback);
    })
    .catch((error) => {
      reportError(error, 'error when trying to reset user password');
      failed(error, onFailureCallback);
    });
};
